// const cms_url = process.env.REACT_APP_CMS;
const upp_url = process.env.REACT_APP_UPP;
const app_url = process.env.REACT_APP_APP;
const login_url = process.env.REACT_APP_LOGIN;
const readname_url = process.env.REACT_APP_READNAME;
const msky_url = process.env.REACT_APP_MSKY;
let luckyDraw_url = process.env.REACT_APP_APP + 'luckyDraw';
const djpapp_url = process.env.REACT_APP_DJP;
const djph5_url = process.env.REACT_APP_DJPH;
const jsj_url = process.env.REACT_APP_JSJ;
const dkbc_url = process.env.REACT_APP_DKBC;
const vip_url = process.env.REACT_APP_VIP;
const ewxl_url = process.env.REACT_APP_EWXL;
const yrdz_url = process.env.REACT_APP_YRDZ;

const personal_order_url = process.env.REACT_APP_JPDD;
const order_center_url = process.env.REACT_APP_MYORDER;
// const common_query_more_url =
//   process.env.REACT_APP_APP + 'common/#/query/general/more';
// const common_query_easy_url =
//   process.env.REACT_APP_APP + 'common/#/query/general/easy';
// const common_query_qrcode_url =
//   process.env.REACT_APP_APP + 'common/#/query/qrCode';
const online_service_app_url = process.env.REACT_APP_serviceApp;
const online_service_web_url = process.env.REACT_APP_serviceWeb;
const online_service_wx_url = process.env.REACT_APP_serviceWx;

const common_facequery_more_url =
  process.env.REACT_APP_APP + 'ticketRefund/#/ticket/facemoreQurey';
const common_query_more_url =
  process.env.REACT_APP_APP + 'msite/#/auth/query/login/more';
const common_query_easy_url =
  process.env.REACT_APP_APP + 'msite/#/auth/query/login/easy';
const common_query_qrcode_url =
  process.env.REACT_APP_APP + 'msite/#/auth/query/qrCode';

const msiteDeatils = process.env.REACT_APP_APP + 'msite/#/details';
const msiteChangeSubmit = process.env.REACT_APP_APP + 'msite/#/changeApply';
const addPsgsInfo_url = process.env.REACT_APP_APP + 'msite/#/add/info';
const addPsgsPnrInfo_url = process.env.REACT_APP_APP + 'msite/#/add/PnrPsgInfo';

const openWallet = process.env.REACT_APP_Wallet;

if (
  process.env.REACT_APP_PKG === 'dev' &&
  window.CSNativeObject &&
  window.CSNativeObject.nativeSetTitle &&
  typeof window.CSNativeObject.nativeSetTitle === 'function'
) {
  luckyDraw_url = process.env.REACT_APP_APP_HOST + 'luckyDraw';
}

export default {
  addPsgsInfo_url,
  addPsgsPnrInfo_url,
  msiteChangeSubmit,
  msiteDeatils,
  common_facequery_more_url,
  common_query_more_url,
  common_query_easy_url,
  common_query_qrcode_url,
  app_config_url: '/public/config.json',
  cms_url: '/EMP/getAds',
  openWallet,
  msky_url,
  upp_url,
  app_url,
  login_url,
  readname_url,
  luckyDraw_url,
  // 接送机
  jsj_url,
  // 登机牌
  djpapp_url,
  djph5_url,
  // 代客泊车
  dkbc_url,
  // 贵宾休息室
  vip_url,
  // 额外行李
  ewxl_url,
  // 一人多座
  yrdz_url,
  //SO跳转机票订单
  personal_order_url,
  // 我的订单中心
  order_center_url,
  // 在线客服
  online_service_app_url,
  online_service_web_url,
  online_service_wx_url,
  // 查询配置开关
  getConfig: '/EMP/isPropertiesTrue',
  //通用开关接口
  commonSystemSwitch: '/EMP/memberSystemSwitch',
  // 查询当前用户是否登录
  getUserStatus: '/EMP/loginStatus',
  // 查询可退改状态的客票，(根据客票号之类的搜索)
  getTicektList: '/EMP/queryOrderTickets',
  // 更多客票查询
  getMoreTicektList: '/EMP/moreQuery',
  // 扫描登机牌查询
  getWXTicektList: '/EMP/wxopenQuery',
  // ss
  getSsTicektList: '/EMP/involLoginQuery', // 废弃
  // 简易登录查询
  getEasyTicektList: '/EMP/easyLoginQuery',
  // 查询处理中、已退改状态客票
  getIntreatmentBack: '/EMP/getIntreatmentBack',
  // 校验（退票校验，变更校验）变更
  checkOrderTicket: '/EMP/checkOrderTicket',
  checkOrderTicketTPWL: '/EMP/checkOrderTicketTPWL',
  // 变更、退票航段校验
  checkTicketFlight: '/EMP/checkTicketFlight',
  checkTicketFlightTPWL: '/EMP/checkTicketFlightTPWL',
  // 检测航班日期
  checkFlightDate: '/EMP/checkFlightDate',
  // 提交非自愿变更申请
  afterSaleChangeReqPayOK: '/EMP/afterSaleChangeReqPayOK',
  // 缺失项校验提交变更申请
  afterSaleChangeConfirm: '/EMP/afterSaleChangeConfirm',
  // 提交自愿变更申请
  afterSaleVolChangeReqPayOK: '/EMP/afterSaleVolChangeReqPayOK',
  // 提交退票申请
  afterSaleRefundApp: '/EMP/afterSaleRefundApp',
  // 退票提交验证码校验
  checkVerificationCode: '/EMP/checkVerificationCode',
  // 获取变更详情
  afterSaleChangeReqDetail: '/EMP/afterSaleChangeReqDetail',
  // 获取退票详情
  afterGetRefundOrderDetail: '/EMP/afterGetRefundOrderDetail',
  // 获取退票费
  afterSaleRefundFee: '/EMP/afterSaleRefundFee',
  // 创建TA单
  createRefundTa: '/EMP/createRefundTa',
  //创建挽留TJ单
  submitFastRefundMultiple: '/EMP/submitFastRefundMultiple',
  // 身份验证
  identityPayAuthInfo: '/EMP/identityPayAuthInfo',
  // 退改费用查询
  queryRefundChangeFee: '/EMP/queryRefundChangeFee',
  // 退票手续费
  queryRefundFee: '/EMP/queryRefundFee',
  // 变更手续费
  queryChangeFee: '/EMP/queryChangeFee',
  // 2018.03.16 该需求暂定 行程单回收通知
  // strokeNotice: '/EMP/checkedReceipt'
  // 取消值机
  cancelCheckIn: '/EMP/cancelCheckIn',
  // 查询新航班
  changeReqNewFlightDetail: '/EMP/afterSaleChangeReqNewFlightDetail',
  // 取消变更单
  cancleChangePayIn: '/EMP/cancleChangePayIn',
  // 取消OO变更单
  cancleChangeOOPayIn: '/EMP/cancleChangeOOPayIn',
  // 去支付
  volunteerChangePay: '/EMP/volunteerChangePay',
  // 支付成功后的回调接口
  // volunteerChangePaymentCallBack: '/EMP/ChangePaymentCallBack',
  // 推荐升舱
  queryChangeCost: '/EMP/queryChangeCost',
  // 银行卡
  searchAuthInfo: '/EMP/searchAuthInfo',
  // 简易登录
  easyLoginQuery: '/EMP/easyLoginQuery',
  // 退票，变更获取联系人和电话
  getNameAndPhone: '/EMP/getNameAndPhone',
  // 获取验证码
  getVerificationCode: '/EMP/getVerificationCode',
  // 获取是否展示退款方式
  getRefundMode: '/EMP/getRefundMode',
  //获取电子发票信息
  getSvcPcInvoiceInfoByIdAndType: '/EMP/getSvcPcInvoiceInfoByIdAndType',
  //新增电子发票信息
  saveSvcPcInvoiceDto: '/EMP/saveSvcPcInvoiceDto',
  //生成电子发票
  createInvoice: '/EMP/createInvoice',
  //获取电子发票是否展示
  showEiEntrance: '/EMP/showEiEntrance',
  //退票详情页电子发票详情
  getPrintableTickets: '/EMP/getPrintableTickets',
  // upp
  uppPay: `${upp_url}upp_cashier/upp-web/dist/pages/h5/orderPay.html`,
  // 获取X产品
  queryRefundExtendDetail: '/EMP/queryRefundExtendDetail',
  // upp 支付成功回调地址
  // payCallBackUrl: `${app_url}msite/#/common/payResult/msite?`, // `${app_url}ticketRefund/#/ticket/pay`,
  payCallBackUrl: `${app_url}ticketRefund/#/ticket/pay`,
  // 简易登录
  easyLogin: `${app_url}ticketRefund/#/ticket/easyLogin`,
  pageInfoDto: {
    historyUrl: `${app_url}ticketRefund/#/ticket/updateDetail`,
    homeUrl: `${app_url}ticketRefund/#/ticket/updateDetail`,
    overTimeUrl: `${app_url}ticketRefund/#/ticket/updateDetail`,
    reOrderUrl: `${app_url}ticketRefund/#/ticket/updateDetail`,
  },
  // 退改计算器列表页面
  queryCalculatorTickets: '/EMP/queryCalculatorTickets',
  // 退改计算器免登
  getLoginSessionTemp: '/EMP/getLoginSessionTemp',
  // 检测抽奖入口
  checkLuckDrawEntry: '/EMP/marketingActivities/checkLuckDrawEntry',
  // 获取退改规则
  getOriginFlightUseCondition: '/EMP/getOriginFlightUseCondition',
  // 支付里程
  exchangePayMileage: '/EMP/exchangePayMileage',
  // 里程验证
  checkSvcFfpMemberPwd: '/EMP/checkSvcFfpMemberPwd',
  // 人脸识别校验
  faceRecognition: '/EMP/faceRecognition',
  // 获取变更优惠券
  getCoupons: '/EMP/touchSearchBGQ',
  // 预定选座
  reserveNewSeat: '/EMP/reservedNewFlightDetail',
  reserveNewSeatUrl: `${
    process.env.REACT_APP_PKG === 'dev'
      ? 'http://mtest.csair.com:7071/'
      : process.env.REACT_APP_LOGIN
  }touch/com.csair.mbp.index/index.html#com.csair.mbp.prechooseseat/seatChooseLogin`,
  // 快速受理
  fastRefundUrl: `${process.env.REACT_APP_APP}msite/#/fastRefund/submit`,
  fastChange: `${process.env.REACT_APP_APP}msite/#/fastChange/submit`,
  busy: `${process.env.REACT_APP_APP}msite/#/common/selectOperate`,
  autoFastRefund: '/EMP/autoFastRefund',
  createE2ERefund: '/EMP/createE2ERefund',
  verifyPnrPassengerBirthday: '/EMP/verifyPnrPassengerBirthday',
  getUserInfo: '/EMP/userinfo',
  touchConfirmIntVol: '/EMP/touchConfirmIntVol',
  checkPnrDocs: '/EMP/checkPnrDocs',
  createE2EChange: '/EMP/createE2EChange',
  createMuChange: '/EMP/createChangeByMU', //东航创单
  xProductUrl: `${
    process.env.REACT_APP_HOLIDAY
  }waptuan/login/tuanorder/TuanOrderAction.shtml?mhd=getOrderList`,
  getPassageMemberLevel: '/EMP/marketingActivities/getPassageMemberLevel',
  createNpsQnrDetail: '/EMP/marketingActivities/createNpsQnrDetail',
  getRefundWalletInfo: '/EMP/getRefundWalletInfo',
  createGPChange: '/EMP/createGPChange',
  touchRefundSearchBGQ: '/EMP/touchRefundSearchBGQ',
  getScheme: '/EMP/getWechatAppLink',
  getFlightRules: '/EMP/getDomesticFlightRules',
  // 获取保险
  getInsurancecChange: '/EMP/insurancecChange',
  getProductShopList: '/EMP/loungeChange',
  uploadRefundFile: '/EMP/uploadRefundFile',
  searchRefundAttachment: '/EMP/searchRefundAttachment', // 散客、团体
  uploadRCattachment: '/EMP/uploadRCattachment',
  updateFileList: '/EMP/updateFileList',
  searchNpsUrl: '/EMP/searchNpsUrl',
  greenFlightServe: '/EMP/greenFlight',
  isGreenSwitchOn: '/EMP/isGreenSwitchOn',
  memberSystemSwitch: '/EMP/memberSystemSwitch', //获取里程字段开关
  getMenuList: '/EMP/getMenuList', //获取错构服务列表
  getTips: '/EMP/getTips', //错购提示语
  getAdInfo: '/EMP/getAdInfo', //列表广告
  getPackageDate: '/EMP/getPackageDate', //套票自愿变更校验
  encrypFlights: '/EMP/getAnthCode', //防航班信息篡改，加密航班信息
  memberAllSwitch: '/EMP/memberBatchSystemSwitch', //统一开关集合
  customerUrlSwitchOn: ' /EMP/customerUrlSwitchOn', //诉求单及客服开关集合
  getWrongPurchaseTicket: '/EMP/queryOrderTicketCuoGou', //错构列表
  getAreaCodeList: '/EMP/getAreaCodeList',
  getMilageFlightRules: '/EMP/modelCommissionConfig',
  resetSubmitReason: '/EMP/changeRefundStatusNtoS',
  createXSOOrder: '/EMP/createXSOOrder', //X资源创单
  queryUppPayResult: '/EMP/queryUppPayResult',
  customerServiceTickets: '/EMP/customerServiceTickets',
  downloadFile: '/EMP/downloadFile', //附件下载
  HuFlightProtectionCheck: '/EMP/HuFlightProtectionCheck', //海航非自愿航班保护
  getWxAuthResult: '/EMP//getWxAuthResult', //查询实名认证结果接口
};



// WEBPACK FOOTER //
// ./src/config/urlConfig.js